export default __webpack_public_path__ + "static/media/logo9.ef53ed97.png";